import React, { useEffect, useRef } from 'react';
import { FaCheck, FaChevronDown } from 'react-icons/fa';

export default function OpeningFamilyPicker({ families, value, onChange }) {
  const picker = useRef(null);
  useEffect(() => {
    const dismiss = event => {
      if (!picker.current.contains(event.target)) picker.current.open = false;
    };
    document.addEventListener('pointerdown', dismiss);
    return () => document.removeEventListener('pointerdown', dismiss);
  }, []);

  const close = () => {
    picker.current.open = false;
    picker.current.querySelector('summary').focus();
  };
  const navigate = event => {
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    picker.current.open = true;
    const buttons = [...picker.current.querySelectorAll('button')];
    const current = buttons.indexOf(document.activeElement);
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1
      : current < 0 ? families.indexOf(value)
      : (current + (event.key === 'ArrowDown' ? 1 : -1) + buttons.length) % buttons.length;
    buttons[next].focus();
  };

  return <>
    <span id="opening-family-label" className="opening-field-label">Opening family</span>
    <details ref={picker} className="opening-family-picker" onKeyDown={navigate}
      onBlur={event => { if (!event.currentTarget.contains(event.relatedTarget)) event.currentTarget.open = false; }}>
      <summary className="min-h-12" aria-labelledby="opening-family-label opening-family-value">
        <span id="opening-family-value">{value}</span><FaChevronDown aria-hidden="true" />
      </summary>
      <div className="opening-family-options" role="group" aria-labelledby="opening-family-label">
        {families.map(family => <button className="min-h-12" key={family} type="button" aria-pressed={family === value}
          onClick={() => { onChange(family); close(); }}>
          <span>{family}</span>{family === value && <FaCheck aria-hidden="true" />}
        </button>)}
      </div>
    </details>
  </>;
}
